import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService } from 'shared-components';
import { AdminService } from '../../../services/admin.service';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { EtiquetadoService } from 'projects/packcert-web/src/app/modules/etiquetado/services/etiquetado.service';

@Component({
    selector: 'app-lic-new-edit',
    templateUrl: './new-edit.component.html'
})
export class LicNewEditComponent implements OnInit {

    private licencia;
    public versionesSW: Array<any>;

    public newEditForm: UntypedFormGroup;

    public showError: boolean;
    public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
    public mensajes = new Array<Message>();

    private toCloseSpinner: number;

    @Input() licenciaId: number;
    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();


    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _adminService: AdminService
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            etiquetador: [{value: '', disabled: this.getRolePermission()}, Validators.required],
            numeroActivaciones: [{value: '', disabled: this.getRolePermission()}, Validators.required],
            numeroActivacionesMax: [{value: '', disabled: this.getRolePermission()}, Validators.required],
            numeroMovimientosMax: [{value: '', disabled: this.getRolePermission()}, Validators.required],
            habilitada: [''],
            fechaExpiracion: [{value: '', disabled: this.getRolePermission()}],
            diasAvisoExpiracion: [{value: '', disabled: this.getRolePermission()}],
            diasPeriodoGracia: [{value: '', disabled: this.getRolePermission()}],
            idioma: [{value: '', disabled: this.getRolePermission()}, Validators.required],
            temporizadorConfirmacionesPendientes: [{value: '', disabled: this.getRolePermission()}, Validators.required],
            versionPendienteActualizar: [{value: '', disabled: this.getRolePermission()}],
            aplicacion: [{value: this.aplicacion[0], disabled: this.getRolePermission()}, Validators.required]
        });

        this.getVersionesSW();

        if (this.licenciaId) {
            this.newEditForm.get('numeroActivacionesMax').clearValidators();
            this.newEditForm.get('numeroActivacionesMax').updateValueAndValidity();
        } else {
            this.newEditForm.get('numeroActivaciones').clearValidators();
            this.newEditForm.get('numeroActivaciones').updateValueAndValidity();
        }
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get etiquetadores() {
        return this._dataProvider.etiquetadores;
    }

    public get idiomas() {
        return this._dataProvider.idiomas;
    }

    public get confirmacionesPendientes() {
        return this._dataProvider.confirmacionesPendientes;
    }

    public get aplicacion() {
        return this._dataProvider.aplicacion;
    }

    private getVersionesSW() {
        this._spinnerService.showSpinner();
        this._adminService.getVersionesSW().toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.versionesSW = resp;

            if (this.licenciaId) {
                this.getLicencia();
            }
        });
    }

    public getLicencia() {
        this._spinnerService.showSpinner();
        this._adminService.getLicencia(this.licenciaId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.licencia = resp;
            this.newEditForm.patchValue(resp);
            this.newEditForm.patchValue({
                etiquetador: this.etiquetadores.find(x => x.id === resp.etiquetadorId),
                idioma: this.idiomas.find(x => x.id === resp.idiomaId),
                temporizadorConfirmacionesPendientes:
                        this.confirmacionesPendientes.find(x => x.value === resp.configuracionSwEtiquetado.temporizadorConfirmacionesPendientes),
                versionPendienteActualizar: this.versionesSW.find(x => x.id === resp.configuracionSwEtiquetado.versionPendienteActualizarId),
                aplicacion: resp.configuracionSwEtiquetado.tipoAplicacionEtqId === 1 ? this.aplicacion[0] : null
            });
        }, (error) => {
            this.showApiError = true;
            if (error.status === 420) {
                this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.licenciaId) {
            this.licencia = {
                tipoSwId: 1,
                etiquetadorId: this.newEditForm.get('etiquetador').value ? this.newEditForm.get('etiquetador').value.id : null,
                numeroActivaciones: this.newEditForm.get('numeroActivaciones').value ? this.newEditForm.get('numeroActivaciones').value.toString() : null,
                numeroActivacionesMax: this.newEditForm.get('numeroActivacionesMax').value ? this.newEditForm.get('numeroActivacionesMax').value : null,
                numeroMovimientosMax: this.newEditForm.get('numeroMovimientosMax').value ? this.newEditForm.get('numeroMovimientosMax').value : null,
                habilitada: true,
                fechaExpiracion: this.newEditForm.get('fechaExpiracion').value ? this.newEditForm.get('fechaExpiracion').value : null,
                diasAvisoExpiracion: this.newEditForm.get('diasAvisoExpiracion').value ? this.newEditForm.get('diasAvisoExpiracion').value : null,
                diasPeriodoGracia: this.newEditForm.get('diasPeriodoGracia').value ? this.newEditForm.get('diasPeriodoGracia').value : null,
                idiomaId: this.newEditForm.get('idioma').value ? this.newEditForm.get('idioma').value.id : null,
                configuracionSwEtiquetado: {
                    temporizadorConfirmacionesPendientes: this.newEditForm.get('temporizadorConfirmacionesPendientes').value ?
                                this.newEditForm.get('temporizadorConfirmacionesPendientes').value.value : null,
                    ventanaTiempoAvisoSinConexion: 0,
                    ventanaTiempoBloqueoSinConexion: 0,
                    ventanaTiempoAvisoSinConexionHoras: 0,
                    ventanaTiempoBloqueoSinConexionHoras: 0,
                    versionPendienteActualizarId: this.newEditForm.get('versionPendienteActualizar').value ?
                                this.newEditForm.get('versionPendienteActualizar').value.id : '',
                    tipoAplicacionEtqId: this.newEditForm.get('aplicacion').value ? this.newEditForm.get('aplicacion').value.id : 1
                }
            };
            this._spinnerService.showSpinner();
            this._adminService.createLicencia(this.licencia).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
              (resp) => {
                if (resp.id) {
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemCreated');
                } else {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
              },
              (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
              }
            );
        } else if (this.newEditForm.valid && this.licenciaId) {
            this.licencia = {
                id: this.licenciaId,
                tipoSwId: 1,
                etiquetadorId: this.newEditForm.get('etiquetador').value ? this.newEditForm.get('etiquetador').value.id : null,
                numeroActivaciones: this.newEditForm.get('numeroActivaciones').value,
                numeroActivacionesMax: this.newEditForm.get('numeroActivacionesMax').value ? this.newEditForm.get('numeroActivacionesMax').value : null,
                numeroMovimientosMax: this.newEditForm.get('numeroMovimientosMax').value ? this.newEditForm.get('numeroMovimientosMax').value : null,
                habilitada: this.newEditForm.get('habilitada').value ? this.newEditForm.get('habilitada').value : false,
                fechaExpiracion: this.newEditForm.get('fechaExpiracion').value ? this.newEditForm.get('fechaExpiracion').value : null,
                diasAvisoExpiracion: this.newEditForm.get('diasAvisoExpiracion').value ? this.newEditForm.get('diasAvisoExpiracion').value : null,
                diasPeriodoGracia: this.newEditForm.get('diasPeriodoGracia').value ? this.newEditForm.get('diasPeriodoGracia').value : null,
                idiomaId: this.newEditForm.get('idioma').value ? this.newEditForm.get('idioma').value.id : null,
                configuracionSwEtiquetado: {
                    temporizadorConfirmacionesPendientes: this.newEditForm.get('temporizadorConfirmacionesPendientes').value ?
                                this.newEditForm.get('temporizadorConfirmacionesPendientes').value.value : null,
                    ventanaTiempoAvisoSinConexion: 0,
                    ventanaTiempoBloqueoSinConexion: 0,
                    ventanaTiempoAvisoSinConexionHoras: 0,
                    ventanaTiempoBloqueoSinConexionHoras: 0,
                    versionPendienteActualizarId: this.newEditForm.get('versionPendienteActualizar').value ?
                                this.newEditForm.get('versionPendienteActualizar').value.id : '',
                    tipoAplicacionEtqId: this.newEditForm.get('aplicacion').value ? this.newEditForm.get('aplicacion').value.id : 1
                }
            };
            this._spinnerService.showSpinner();
            this._adminService.updateLicencia(this.licencia).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemUpdated');
                },
                (error) => {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            );
        }
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

    public getRolePermission() {
        let disabled = false;

        if (this.role === 'Administrador') {
            disabled = false;
        } else if (this.role === 'Auditor') {
            disabled = true;
        } else if (this.role === 'Supervisor') {
            disabled = true;
        } else if (this.role === 'Etiquetador') {
            disabled = true;
        }

        return disabled;
    }
}
